import { CategoryId } from "../../common/constants/commonConstants";
import { Equity, SkuData } from "../../model/store/modules/ticket";
import { getCouponBaseInfo } from "../../model/utils";
import { EquityTypeEnum } from "./enum";

// 渲染标题，区分数字和非数字样式
export const splitTitle = (title: string) => {
  // 使用正则表达式匹配连续的数字或非数字字符
  const regex = /\d+|\D+/g;
  const matches = title.match(regex) || [];

  return matches.map((text) => ({
    text,
    isNumber: /^\d+$/.test(text),
  }));
};

/**
 * 格式化价格小数位数
 * 规则：
 * - 取数至小数点后两位
 * - 最后一位非0，保留全部
 * - 后一位为0，去除最后的0，如10.10改为10.1
 * - 后两位均为0，省略00，如10.00改成10
 */
export const formatPrice = (price: number | string): string => {
  // 统一转换为字符串格式
  const priceStr = typeof price === 'number' ? price.toFixed(2) : price;
  const [integerPart, decimalPart = '00'] = priceStr.split('.');

  if (decimalPart === '00') {
    return integerPart;
  }

  if (decimalPart.length >= 2 && decimalPart[1] === '0') {
    return `${integerPart}.${decimalPart[0]}`;
  }

  return `${integerPart}.${decimalPart.substring(0, 2)}`;
};

/**
 * 渲染价格，将整数、小数点、小数部分分别处理
 * 返回格式化后的价格对象，用于 JSX 渲染
 */
export const renderPrice = (price: number | string) => {
  const priceStr = typeof price === 'number' ? price.toString() : price;
  const parts = priceStr.split('.');

  return {
    integer: parts[0],
    hasDecimal: parts.length > 1,
    decimal: parts[1] || '',
  };
};

// 券权益取前两个权益，如果其中有一个权益getCouponBaseInfo获取的num值不存在，则返回false，否则返回true, 用于券包展示
export const couponHasNum = (equityList: Equity[]) => equityList.slice(0, 2)
  .every((equity) => !!getCouponBaseInfo(equity).num);

/** renderBenefit 返回值类型 */
export type RenderBenefitResult = {
  /** 是否为券包 */
  couponPackage: boolean;
  /** 商品名称 */
  goodsName?: string;
  /** 商品标签 */
  goodsTags?: string[];
  /** 权益数量（仅券包时存在） */
  equityCount?: number;
  /** 券列表（仅券包时存在，最多2个） */
  couponList?: Equity[];
  /** 是否有更多券（仅券包时存在） */
  hasMore?: boolean;
};

// 处理权益类型展示
export const renderBenefit = (skuData: SkuData): RenderBenefitResult => {
  const {
    goodsEquitys, categoryId, goodsName, goodsTags,
  } = skuData;

  // 是否是券包权益: 要求所有权益都是券包
  const isCouponPackage = goodsEquitys?.every(
    (item) => item.propertyType === EquityTypeEnum.COUPON,
  );
  // 两轮类目
  const isTwoWheel = [CategoryId.BIKE, CategoryId.EBIKE].includes(
    categoryId as CategoryId,
  );

  // 基础配置
  const commonConfig = {
    couponPackage: false,
    goodsName,
    goodsTags,
  };

  // 两轮券包：使用基础配置
  if (isCouponPackage && isTwoWheel) {
    return commonConfig;
  }

  // 普通全部券包权益 - 接口返回相关优惠字段，使用券包配置，无相关配置使用基础配置
  if (isCouponPackage && !isTwoWheel) {
    if (couponHasNum(goodsEquitys)) {
      // virtualNum 的累加
      const equityCount = goodsEquitys.reduce((sum, item) => sum + (item.virtualNum || 0), 0);
      return {
        couponPackage: true,
        equityCount,
        couponList: goodsEquitys.slice(0, 2),
        hasMore: goodsEquitys.length > 2,
      };
    }
    return commonConfig;
  }
  // 卡权益 || 电池套餐 以及 其他
  return commonConfig;
};
